module.exports = __webpack_public_path__ + "assets/img/home8.c7bd5c72.png";